import { associatedUserStates } from '/business/shared/util/Statics';
import type { AssociatedUser } from '/business/shared/functions/types';

function getAssociatedUsersByRole(associatedUsers: AssociatedUser[], role: string): AssociatedUser[] {
  const order = {
    [associatedUserStates.ACCEPTED]: 1,
    [associatedUserStates.PENDING]: 2,
    [associatedUserStates.DECLINED]: 3,
    default: 1000,
  };

  return (
    associatedUsers
      .filter((associatedUser) => associatedUser.role === role)
      .sort((a, b) => {
        return (
          (order[a.invite_state as keyof typeof order] || order.default) -
          (order[b.invite_state as keyof typeof order] || order.default)
        );
      }) || []
  );
}

export default getAssociatedUsersByRole;
